import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { HttpAlertService } from '../../services/http-alert.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-http-alert',
  templateUrl: './http-alert.component.html',
})
export class HttpAlertComponent implements OnInit, OnDestroy {
  private subscription: Subscription;
  showLoader: boolean;

  constructor(private alertService: HttpAlertService, private messageService: MessageService) {  }

  ngOnInit() {
    this.subscription = this.alertService.getMessage().subscribe(msg => {
      if (typeof msg !== 'undefined' ) {
        this.messageService.add({severity: msg.type, summary: msg.text, detail: msg.desc});
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
